import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-causes-modal',
  templateUrl: './add-causes-modal.component.html',
  styleUrls: ['./add-causes-modal.component.scss']
})
export class AddCausesModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;

  form: UntypedFormGroup;
  
  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      selectedCauses: [this.user.causes],
    });
  }

  onClose() {
    this.closed.emit();
  }
}
